import { lazy, Suspense } from 'react'
import type { ComponentProps } from 'react'
import type SimTradeBoxInner from '@/components/SimTradeBox'

/**
 * Client-only boundary for the curve trade box.
 *
 * `SimTradeBox` imports `useCurveWrites` (wagmi → WalletConnect), which cannot
 * be evaluated by the Node/ESM prerender pass. Loading it lazily keeps the
 * static build free of `require("ws")`.
 *
 * DO NOT convert this back into a static import.
 */
const SimTradeBox = lazy(() => import('@/components/SimTradeBox'))

type SimTradeBoxLazyProps = ComponentProps<typeof SimTradeBoxInner>

function SimTradeBoxLazy(props: SimTradeBoxLazyProps) {
  return (
    <Suspense
      fallback={(
        <div className="rounded-3xl border border-white/10 bg-white/[0.03] p-6 text-sm text-zinc-400 backdrop-blur-md">
          Loading trade box…
        </div>
      )}
    >
      <SimTradeBox {...props} />
    </Suspense>
  )
}

export default SimTradeBoxLazy
